import React from "react";

import MinusIcon from "@common/assets/images/members/cancel-invitation-icon.svg";
import PendingIcon from "@common/assets/images/members/invite-avatar.svg";
import ResendIcon from "@common/assets/images/resend-icon.svg";
import RoundedCanvas from "@common/components/RoundedCanvas/RoundedCanvas";
import Tooltip from "@common/components/Tooltip/Tooltip";
import { Invitation } from "@common/models/Member.model";
import { vars } from "@common/styles/abstracts/vars";
import identifiers from "@common/util/identifiers.json";
import { getTag, TagDetails } from "@main/pages/Administration/components/TeamMembersCard/TeamMemberRows/TeamMemberRow";
import * as Styled from "main/pages/Administration/components/TeamMembersCard/TeamMemberRows/TeamMemberRow.styles";

interface Props {
  invitation: Invitation;
  currentUserIsAdmin: boolean;
  onCancelInvite: () => void;
  handleResendInvite: () => void;
}

export const TeamMemberInvitationRow = ({
  invitation,
  currentUserIsAdmin,
  onCancelInvite,
  handleResendInvite,
}: Props) => {
  const { email } = invitation;

  const tag: TagDetails = getTag(invitation.role);

  return (
    <Styled.Row>
      <div style={{ display: "flex", flex: 2, alignItems: "center" }}>
        <RoundedCanvas
          image={PendingIcon}
          bgColor={vars.colors.grey80}
          size="small"
          data-testid={identifiers["member.myTeam.user.pending.icon"]}
          style={{ marginRight: "1.2rem" }}
        />
        <Styled.Name data-testid={identifiers["member.myTeam.user.pending.name"]}>{email}</Styled.Name>
      </div>

      <div style={{ display: "flex", flex: 1, alignItems: "center" }}>
        <Styled.RowTag
          color={tag.color}
          value={tag.text}
          border
          borderColor={vars.colors.grey90}
        />
        <Styled.RowTag
          color={vars.colors.white}
          value={"pending"}
          border
          borderColor={vars.colors.grey90}
        />
      </div>

      <div style={{ display: "flex", flexBasis: "10rem", alignItems: "center", justifyContent: "end" }}>
        {currentUserIsAdmin ? (
          <Styled.ActionsWrap className={"members-row-actions"}>
            <Tooltip
              text={"Resend invite"}
              position={"top"}
            >
              <Styled.ActionButton onClick={handleResendInvite}>
                <img
                  src={ResendIcon}
                  alt={"Resend invite"}
                />
              </Styled.ActionButton>
            </Tooltip>
            <Tooltip
              text={"Cancel invite"}
              position={"top"}
            >
              <Styled.ActionButton onClick={onCancelInvite}>
                <img
                  src={MinusIcon}
                  alt={"Cancel invite"}
                />
              </Styled.ActionButton>
            </Tooltip>
          </Styled.ActionsWrap>
        ) : null}
      </div>
    </Styled.Row>
  );
};
